import React, { useEffect } from "react";

import { api } from "../../../../../../../utility/AxiosInceptor";
import "./css/PortInHistory.css";
export default function PortInHistory({ currentSelected }) {
  useEffect(() => {
    api
      .get(`/api/user/getMdnHistory?customerId=${currentSelected?._id}`)
      .then(() => {})
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <table className="tablebody">
        <thead>
          <tr>
            <td>Primary Number</td>
            <td>Account ID</td>
            <td>Status</td>
            <td>Actions</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td> </td>
            <td> </td>
            <td></td>
            <td>...</td>
          </tr>
          <tr>
            <td> </td>
            <td> </td>
            <td></td>
            <td>...</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
